import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

const ExcelUploadModal = ({ visible, onHide, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [status, setStatus] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setStatus("");
  };

  const handleUpload = () => {
    if (!selectedFile) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    fetch(API() + "/sondages/upload-new-source-sondages-excel", {
      method: "POST",
      headers: {
        Authorization: getAuthHeader(),
      },
      body: formData,
    })
      .then((res) => res.json().then((data) => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status === 201) {
          setStatus(data);
          onSuccess?.();
        } else {
          setStatus(data);
        }
      })
      .catch((err) => {
        setStatus("Error: " + err.message);
      })
      .finally(() => setUploading(false));
  };

  const footer = (
    <>
      <Button label="Close" onClick={onHide} className="p-button-text" />
      <Button
        label="Upload"
        onClick={handleUpload}
        disabled={!selectedFile || uploading}
      />
    </>
  );

  return (
    <Dialog
      header="Import Sondages from Excel"
      visible={visible}
      style={{ width: "40vw" }}
      footer={footer}
      onHide={onHide}
    >
      <input type="file" accept=".xls,.xlsx" onChange={handleFileChange} />
      {selectedFile && <p>Selected: {selectedFile.name}</p>}
      {status && (
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "200px",
            overflowY: "auto",
            background: "#f8f8f8",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        >
          {typeof status === "string" ? (
            <p style={{ color: status.startsWith("Error") ? "red" : "green" }}>
              {status}
            </p>
          ) : (
            <>
              <p>
                <b>Inserted:</b> {status.inserted_count}
              </p>
              <p>
                <b>Errors:</b> {status.error_count}
              </p>
              <ul>
                {status.errors.map((e, i) => (
                  <li key={i} style={{ color: "red" }}>
                    {e}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </Dialog>
  );
};

export default ExcelUploadModal;
